import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {PageModule} from '../page/page.module';
import {LoginPage} from '../page/all/login/login.page';
import {GeenToegangPage} from '../page/all/geentoegang/geen-toegang.page.component';
import {LandingGuard} from './landing.guard';
import {AuthGuard} from '../core/auth/auth.guard';
import {RegioverantwoordelijkenPage} from '../page/admin/regioverantwoordelijken/regioverantwoordelijken.page';
import {AddRegioverantwoordelijkePage} from '../page/admin/add-regioverantwoordelijke/add-regioverantwoordelijke.page';
import {TherapeutenPage} from '../page/admin/therapeuten/therapeuten.page';
import {ThuisverzorgersPage} from '../page/admin/thuisverzorgers/thuisverzorgers.page';
import {AddTherapeutPage} from '../page/admin/add-therapeut/add-therapeut.page';
import {AddThuisverzorgerPage} from '../page/admin/add-thuisverzorger/add-thuisverzorger.page';
import {AdminsPage} from '../page/admin/admins/admins.page';
import {AddAdminPage} from '../page/admin/add-admin/add-admin-page.component';
import {Role} from '../core/auth/user';
import {ClientenPage} from '../page/regioverantwoordelijke/clienten/clienten.page';
import {AddClientPage} from '../page/regioverantwoordelijke/add-client/add-client.page';
import {StartPrestatiePage} from '../page/thuisverzorger/start-prestatie/start-prestatie.page';
import {EditClientPage} from '../page/regioverantwoordelijke/edit-client/edit-client-page.component';
import {AdminPage} from '../page/admin/admin/admin.page';
import {RegioverantwoordelijkePage} from '../page/admin/regioverantwoordelijke/regioverantwoordelijke.page';
import {ThuisverzorgerPage} from '../page/admin/thuisverzorger/thuisverzorger.page';
import {TherapeutPage} from '../page/admin/therapeut/therapeut.page';
import {PrestatieDienstenPage} from '../page/thuisverzorger/prestatie-diensten/prestatie-diensten.page';
import {StopPrestatiePage} from '../page/thuisverzorger/stop-prestatie/stop-prestatie.page';
import {ClientDienstenBeheerPage} from '../page/regioverantwoordelijke/client-diensten-beheer/client-diensten-beheer.page';
import {PrestatieTakenPage} from '../page/thuisverzorger/prestatie-taken/prestatie-taken.page';
import {PrestatiePage} from '../page/regioverantwoordelijke/prestatie/prestatie.page';
import {PrestatiesPage} from '../page/regioverantwoordelijke/prestaties/prestaties.page';
import {ExportsPage} from '../page/regioverantwoordelijke/exports/exports-page.component';
import {SignaalkaartenPage} from '../page/thuisverzorger/signaalkaarten/signaalkaarten.page';
import {MeldingenPage} from '../page/all/meldingen/meldingen.page';
import {ZoekClientPage} from '../page/therapeut/zoek-client/zoek-client.page';
import {ClientDienstenPage} from '../page/all/client-diensten/client-diensten.page';
import {ActiviteitenPage} from '../page/regioverantwoordelijke/activiteiten/activiteiten.page';
import {TipsPage} from '../page/all/tips/tips.page';
import {SignaalkaartPage} from '../page/thuisverzorger/signaalkaart/signaalkaart.page';
import {SignaalkaartAntwoordenPage} from '../page/all/signaalkaart-antwoorden/signaalkaart-antwoorden.page';
import {SignaalkaartAntwoordPage} from '../page/all/signaalkaart-antwoord/signaalkaart-antwoord.page';
import {ActievePrestatieGuard} from './actieve-prestatie.guard';
import {InactievePrestatieGuard} from './inactieve-prestatie.guard';
import {ClientFicheBeheerPage} from '../page/regioverantwoordelijke/client-fiche-beheer/client-fiche-beheer.page';
import {ClientFichePage} from '../page/all/client-fiche/client-fiche.page';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'home'
  },
  {
    path: 'home',
    component: GeenToegangPage,
    canActivate: [LandingGuard]
  },
  {
    path: 'aanmelden',
    component: LoginPage,
  },
  {
    path: 'geen-toegang',
    component: GeenToegangPage,
  },
  {
    path: 'admins/toevoegen',
    component: AddAdminPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.SUPERADMIN, Role.ADMIN]}},
  },
  {
    path: 'admins/:id',
    component: AdminPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.SUPERADMIN, Role.ADMIN]}},
  },
  {
    path: 'admins',
    component: AdminsPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.SUPERADMIN, Role.ADMIN]}},
  },
  {
    path: 'regioverantwoordelijken/toevoegen',
    component: AddRegioverantwoordelijkePage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'regioverantwoordelijken/:id',
    component: RegioverantwoordelijkePage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'regioverantwoordelijken',
    component: RegioverantwoordelijkenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'therapeuten/toevoegen',
    component: AddTherapeutPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'therapeuten/:id',
    component: TherapeutPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'therapeuten',
    component: TherapeutenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'thuisverzorgers/toevoegen',
    component: AddThuisverzorgerPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'thuisverzorgers/:id',
    component: ThuisverzorgerPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'thuisverzorgers',
    component: ThuisverzorgersPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.ADMIN]}},
  },
  {
    path: 'clienten/zoeken',
    component: ZoekClientPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.THERAPEUT]}}
  },
  {
    path: 'clienten/toevoegen',
    component: AddClientPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:id/wijzigen',
    component: EditClientPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:id/diensten/beheer',
    component: ClientDienstenBeheerPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:id/fiche',
    component: ClientFichePage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.THERAPEUT, Role.THUISVERZORGER]}},
  },
  {
    path: 'clienten/:id/fiche/beheer',
    component: ClientFicheBeheerPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:clientId/meldingen',
    component: MeldingenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER, Role.REGIOVERANTWOORDELIJKE, Role.THERAPEUT]}},
  },
  {
    path: 'clienten/:id/prestaties',
    component: PrestatiesPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:clientId/prestaties/:prestatieId',
    component: PrestatiePage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'clienten/:clientId/tips/dienst/:dienstId/categorie/:categorieId/taak/:taakId',
    component: TipsPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE, Role.THERAPEUT, Role.THUISVERZORGER]}},
  },
  {
    path: 'clienten/:id/signaalkaarten',
    component: SignaalkaartAntwoordenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE, Role.THERAPEUT]}},
  },
  {
    path: 'clienten/:id/signaalkaarten/:signaalkaartAntwoordId',
    component: SignaalkaartAntwoordPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE, Role.THERAPEUT]}},
  },
  {
    path: 'clienten/:id',
    component: ClientDienstenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE, Role.THERAPEUT]}},
  },
  {
    path: 'clienten',
    component: ClientenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'activiteiten',
    component: ActiviteitenPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: 'prestatie/:id/diensten',
    component: PrestatieDienstenPage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'prestatie/:id/stop',
    component: StopPrestatiePage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'prestatie/:id/diensten/:dienstId/taken',
    component: PrestatieTakenPage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'prestatie/:prestatieId/meldingen/:clientId',
    component: MeldingenPage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'prestatie/:prestatieId/signaalkaarten/:clientId',
    component: SignaalkaartenPage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'signaalkaart/:signaalkaartId/cliënt/:clientId',
    component: SignaalkaartPage,
    canActivate: [AuthGuard, ActievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}},
  },
  {
    path: 'prestatie/start',
    component: StartPrestatiePage,
    canActivate: [AuthGuard, InactievePrestatieGuard],
    data: {auth: {requiresOneOfRoles: [Role.THUISVERZORGER]}}
  },
  {
    path: 'exports',
    component: ExportsPage,
    canActivate: [AuthGuard],
    data: {auth: {requiresOneOfRoles: [Role.REGIOVERANTWOORDELIJKE]}},
  },
  {
    path: '**',
    redirectTo: '/home'
  }
];

@NgModule({
  imports: [
    PageModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class RoutingModule {
}
